import { render } from "./OrderDetails.vue?vue&type=template&id=7d69ba6a&scoped=true&ts=true"
import script from "./OrderDetails.vue?vue&type=script&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&lang=ts"

import "./OrderDetails.vue?vue&type=style&index=0&id=7d69ba6a&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d69ba6a"]])

export default __exports__